import { IonIcon, IonLabel, IonList, IonListHeader } from '@ionic/react';
import { checkmarkCircle } from 'ionicons/icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import {
  RedirectHistoryState,
  buildRedirectHistoryState,
} from '../../pages/redirect.hooks';
import { IonItem } from '../ionic/IonItem';
import {
  useOnboardingChecklist,
  useOnboardingChecklistRemaining,
} from './onboarding-checklist.hook';
import './onboarding.css';

const Onboarding = (): ReactElement => {
  const { i18n } = useTranslation();
  const checklist = useOnboardingChecklist();
  const remainingItems = useOnboardingChecklistRemaining();
  const { push } = useHistory<RedirectHistoryState>();

  const navigate = (index: number): void => {
    // based on index will build recursive redirect so we can walk user through the remaing steps
    // without forcing them to click on the items and manually navigates
    const item = checklist[index];

    const paths = checklist
      .slice(index + 1)
      .filter((c) => !c.complete)
      .map((c) => c.path);

    const state: RedirectHistoryState | undefined = buildRedirectHistoryState([
      ...paths,
    ]);

    push(item.path, state);
  };

  if (checklist.length > 0) {
    let heading: string = i18n.t('common:setup_get_started');
    if (remainingItems === 0) {
      heading = i18n.t('common:setup_complete');
    } else if (remainingItems > 0) {
      heading = i18n.t('common:setup_almost_complete');
    }
    return (
      <IonList className="onboarding-checklist">
        <IonListHeader>
          <IonLabel>{heading}</IonLabel>
        </IonListHeader>
        {checklist.map((item, index) => (
          <IonItem
            key={index}
            onClick={(e) => {
              e.preventDefault();
              navigate(index);
            }}
            href=""
            disabled={item.path === undefined || item.complete}
            className={item.className}
          >
            <IonLabel>
              <h2>{item.title}</h2>
              <p>{item.subtitle}</p>
            </IonLabel>
            {item.complete && (
              <IonIcon icon={checkmarkCircle} color="success" size="large" />
            )}
          </IonItem>
        ))}
      </IonList>
    );
  } else {
    return <div />;
  }
};

export { Onboarding };
